import { CFTokens } from '../../../../../tokens';
export const TYPE_SPEC = {
    lg: CFTokens.TYPE_SPEC_SCALE.H_MEDIUM_AUTO,
    md: CFTokens.TYPE_SPEC_SCALE.F_MEDIUM_AUTO,
    sm: CFTokens.TYPE_SPEC_SCALE.E_MEDIUM_AUTO,
};
